import { combineReducers } from 'redux';
import list from './List/reducer';
import edit from './Edit/reducer';
import create from './Create/reducer';

const jurisdictionsReducer = combineReducers({
  list,
  edit,
  create,
});

export default jurisdictionsReducer;
